import React from 'react';

// The two emails a member may turn off, in the order both profile pages show
// them. The keys are the server's `emailPreferences` fields.
export const OPTIONAL_EMAILS = [
    {
        key: 'weeklyDigest',
        label: 'Weekly digest of new listings',
        help: 'One message a week naming what other departments have posted, across all four institutions. Nothing is sent in a week with no new listings.',
    },
    {
        key: 'expiryReminders',
        label: 'Reminders before my listings expire',
        help: 'A warning three days before a listing of yours expires, and a note when it does.',
    },
];

const ALWAYS_SENT = [
    'Confirmation when you post a listing',
    'Confirmation when you request an item, and notice when someone requests yours',
    'Accepted, declined, withdrawn, released and completed requests',
    'Messages on your requests, and questions members ask about your listings',
    'Notice when an administrator removes your listing',
];

/**
 * The member's two switches, read the way the server reads them: anything
 * but an explicit false is on, and a legacy `emailDigest: false` written
 * before `emailPreferences` existed still means the digest is off.
 *
 * @param {object|null} profile
 * @returns {{ weeklyDigest: boolean, expiryReminders: boolean }}
 */
export function readEmailPreferences(profile) {
    const preferences = (profile && profile.emailPreferences) || {};
    return {
        weeklyDigest:
            preferences.weeklyDigest !== false &&
            !(profile && profile.emailDigest === false),
        expiryReminders: preferences.expiryReminders !== false,
    };
}

/**
 * The emails no setting stops, with the reason in one line. Shown on both
 * profile pages so a member never wonders why an email kept arriving after
 * they turned everything off.
 */
export function AlwaysSentEmails({ headingLevel = 'h2' }) {
    const Heading = headingLevel;
    return (
        <section aria-labelledby="always-sent-heading">
            <Heading id="always-sent-heading" className="h6 mt-3">
                Emails that are always sent
            </Heading>
            <p className="small text-muted mb-1">
                These are part of exchanges you take part in, so the other
                department can count on you hearing about them.
            </p>
            <ul className="small mb-0">
                {ALWAYS_SENT.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        </section>
    );
}
